export enum HelperPopupType {
  Size = 'size',
  Colors = 'layout',
  Options = 'options'
}
